// eslint-disable-next-line import/prefer-default-export
export class LanguageConstants {
  static LOCALE_ESPANIOL = 'es' as string;

  static LOCALE_CATALAN = 'ca' as string;

  static LOCALE_EUSKERA = 'eu' as string;

  static LOCALE_GALLEGO = 'gl' as string;

  static LOCALE_INGLES = 'en' as string;

  static LOCALE_ALEMAN = 'de' as string;

  static ID_ESPANIOL = 'C' as string;

  static ID_CATALAN = 'T' as string;

  static ID_EUSKERA = 'E' as string;

  static ID_GALLEGO = 'GAL' as string;

  static ID_INGLES = 'I' as string;

  static ID_ALEMAN = 'A' as string;

  static ALL_LOCALE_IDIOMAS: string[] = [
    LanguageConstants.LOCALE_ESPANIOL,
    LanguageConstants.LOCALE_CATALAN,
    LanguageConstants.LOCALE_EUSKERA,
    LanguageConstants.LOCALE_GALLEGO,
    LanguageConstants.LOCALE_INGLES,
    LanguageConstants.LOCALE_ALEMAN,
  ];
}
